import { Icon } from '@client:common/icon';
import useAssistantChat from 'ai-assistant/hooks/useAssistantChat';
import { UUID } from 'crypto';

import './AssistantMessageFeedback.light.scss';
import './AssistantMessageFeedback.dark.scss';
import { useState } from 'react';

interface Props {
  chat: ReturnType<typeof useAssistantChat>;
  messageId: UUID;
}

export function AssistantMessageFeedback({ chat, messageId }: Props) {
  const [showFeedbackInput, setShowFeedbackInput] = useState(false);
  const [feedbackText, setFeedbackText] = useState('');
  const feedbackForMessage = chat.feedback[messageId];

  const handleThumbUp = () => {
    if (feedbackForMessage?.type === 'positive' && feedbackForMessage?.isSubmitted) {
      return;
    }
    chat.handleFeedbackSubmit(messageId, 'positive');
    setShowFeedbackInput(false);
    setFeedbackText('');
  };

  const handleThumbDown = () => {
    const isAlreadyNegative = feedbackForMessage?.type === 'negative' && feedbackForMessage?.isSubmitted;
    if (isAlreadyNegative) {
      return;
    }
    setShowFeedbackInput(true);
  };

  const submitNegativeFeedback = () => {
    chat.handleFeedbackSubmit(messageId, 'negative', feedbackText);
    setShowFeedbackInput(false);
    setFeedbackText('');
  };

  const cancelNegativeFeedback = () => {
    setShowFeedbackInput(false);
    setFeedbackText('');
  };

  return (
    <div
      className={`assistant-message-feedback ${feedbackForMessage?.isSubmitted ? 'feedback-submitted' : ''
        }`}
    >
      <div className='assistant-message-feedback__actions'>
        <div
          className={`feedback-icon-wrapper ${feedbackForMessage?.type === 'positive' && feedbackForMessage?.isSubmitted ? 'submitted' : ''
            }`}
          onClick={handleThumbUp}
        >
          <Icon icon="thumb_up" />
        </div>
        <div
          className={`feedback-icon-wrapper ${feedbackForMessage?.type === 'negative' && feedbackForMessage?.isSubmitted ? 'submitted' : ''
            }`}
          onClick={handleThumbDown}
        >
          <Icon icon="thumb_down" />
        </div>
      </div>
      {showFeedbackInput && (
        <div className='assistant-message-feedback__input-container'>
          <textarea
            className='assistant-message-feedback__input'
            placeholder='Please provide additional feedback.'
            value={feedbackText}
            onChange={(e) => setFeedbackText(e.target.value)}
          />
          <div className='assistant-message-feedback__button-group'>
            <button
              className='assistant-message-feedback__cancel-button'
              onClick={cancelNegativeFeedback}
            >
              Cancel
            </button>
            <button
              className='assistant-message-feedback__submit-button'
              onClick={submitNegativeFeedback}
            >
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
